module.exports = __webpack_public_path__ + "static/media/true-blue-blue-on-white.82cafa12.jpg";